import { Card, FAQ } from './types';

export const cards: Card[] = [
    {
        id: 1,
        icon: 'card-icon-shipping-leads.svg',
        title: 'Instant Credibility in Global Markets',
        description: 'Being part of DFA adds immediate trust to your name in the freight forwarding industry. With a community that only includes verified, dependable professionals, you instantly show your partners and clients that reliability is at the heart of your business. This credibility opens doors to new markets and opportunities.',
        alt: 'Instant Credibility in Global Markets',
    },
    {
        id: 2,
        icon: 'card-icon-networking.svg',
        title: 'Strengthen Client Loyalty',
        description: 'Reliability is the foundation of lasting partnerships. By leveraging DFA’s resources and reputation, your brand earns the confidence of clients who value trustworthy and consistent service. It’s not just about transactions—it’s about building relationships that last.',
        alt: 'Strengthen Client Loyalty',    
    },
    {
        id: 3,
        icon: 'card-icon-support.svg',
        title: 'Stand Out in Competitive Bids',
        description: 'A strong reputation gives you a decisive edge in negotiations and bids. DFA membership showcases your commitment to quality and professionalism, helping you win contracts and establish long-term business ties more effectively than ever.',
        alt: 'Competitive Bids',
    },
    {
        id: 4,
        icon: 'card-icon-digital-tools.svg',
        title: 'Mitigate Reputation Risks',
        description: 'Protecting your brand is crucial. DFA equips you with tools and best practices to avoid reputation-damaging missteps. Whether through verified partners or transparent transactions, your business stays protected from unreliability and mishandled operations.',
        alt: 'Mitigate Reputation Risks',
    },
    {
        id: 5,
        icon: 'card-icon-brand-reliability.svg',
        title: 'Expand Opportunities with Trust',
        description: 'Trust isn’t just a virtue—it’s a business driver. With DFA\'s brand reliability credentials, more doors open to collaborative ventures, partnerships, and innovative growth opportunities. Your reliability becomes your passport to expansion.',
        alt: 'Expand Opportunities with Trust',
    },
];

export const faq: FAQ[] = [
    {
        id: "1",
        question: "How does being a DFA member enhance my brand’s credibility?",
        answer: (cn: Function) => (
          `
          <p class='${cn('faq__answer-paragraph')}'>
            As a DFA member, your brand aligns with a network of trusted and vetted freight forwarders. This association instantly assures clients and partners of your commitment to reliability and professionalism.
          </p>
          `
        ),
    },
    {
        id: "2",
        question: "Can DFA membership really help me win more contracts?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              Absolutely. Clients and partners are more likely to choose businesses with proven credibility. DFA’s reputation amplifies your trustworthiness, giving you a distinct edge in competitive bids.
            <p/>
          `
        ),
    },
    {
        id: "3",
        question: "How does DFA verify the reliability of its members?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              DFA has a stringent vetting process that includes thorough evaluations of a member’s operational history, client reviews, and adherence to ethical standards. This ensures that only dependable businesses are part of the network.
            </p>
          `
        ),
    },
    {
        id: "4",
        question: "What if my brand is new? Can DFA still help with reliability?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              Yes! Even new brands gain credibility by being part of DFA. The association with a trusted global network helps establish your reliability early in your journey.
            </p>
          `
        ),
    },
    {
        id: "5",
        question: "Will clients and partners know about my DFA membership?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              Definitely. Your DFA membership status can be highlighted in your communications, marketing materials, and digital presence, signalling your brand’s reliability and trustworthiness.
            </p>
          `
        ),
    },
    {
        id: "6",
        question: "How does DFA protect my brand from reputation risks?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              DFA fosters a transparent network and enforces rigorous standards to ensure your partnerships and transactions are risk-free. You also gain access to resources that promote ethical and efficient business practices.
            </p>
          `
        ),
    },
    {
        id: "7",
        question: "Does DFA offer tools to measure the impact of brand reliability?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              Yes, DFA provides insights and metrics to help you gauge the influence of reliability on your business growth, client retention, and overall market reach.
            </p>
          `
        ),
    },
    {
        id: "8",
        question: "Can DFA help my brand expand into new markets?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              Yes! Through DFA, you gain exposure to a global network, allowing you to build trusted connections that facilitate seamless entry into new regions.
            </p>
          `
        ),
    },
    {
        id: "9",
        question: "Is DFA membership suitable for small businesses?",
        answer: (cn: Function) => (
          `
            <p class='${cn('faq__answer-paragraph')}'>
              Absolutely. DFA membership is tailored to businesses of all sizes. Whether you’re a growing enterprise or an established company, you’ll benefit from the trust and opportunities DFA offers.
            </p>
          `
        ),
    },
];